import {
  Injectable,
  Output,
  EventEmitter,
  IterableDiffers,
} from '@angular/core';
import { Filter } from '../core/models/filter';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { ConfigApi } from '../config-api';
import { ApiCallingService } from './services/api-calling.service';
import { sharedBroadcast } from '../pages/footer/footer.component';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class Globals {
  @Output() fire: EventEmitter<any> = new EventEmitter();

  loader = false;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService
  ) {}

  user: any = '';

  private secretKey = 'LNT23';
  colorArray: string[] = [
    '#4f5f6f',
    '#FDD360',
    '#DA6546',
    '#97C1AB',
    '#21D6DD',
    '#F96B42',
    '#7F9AA7',
    '#B79C7B',
    '#7E7474',
    '#A5985F',
    '#C47979',
    '#DF823C',
    '#625FA9',
    '#A95FA7',
    '#636261',
  ];
  encrypt(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(data, this.secretKey).toString();
    return encrypted;
  }

  decrypt(encryptedData: string): string {
    const decrypted = CryptoJS.AES.decrypt(
      encryptedData,
      this.secretKey
    ).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }

  setUser(value: any) {
    this.user = value;
    localStorage.setItem('Auth-user', JSON.stringify(this.user));
  }
  change() {
    this.fire.emit(true);
  }

  getEmittedValue() {
    return this.fire;
  }

  getUser() {
    this.user = localStorage.getItem('Auth-user');
    this.user = JSON.parse(this.user);
    this.user.forEach((row: any) => {
  if (row.CompanyId === '1' || row.CompanyId === '2') {
    row.CompanyId = '1,2';
  }
});

    let companyId = localStorage.getItem('SelcmpId');

    //let dd = this.user.find((val: any) => val.UserId);
      
    
    let dd = this.user.find(
  (val: any) => val.UserId && val.CompanyId === companyId 
);


    // this.authModule = localStorage.getItem('Auth-module')
    // let filterData = JSON.parse(this.authModule);
    return dd;
  }

  //to convert filter object values[array] to string.

  convertFilterToJSON(filter: Filter): any {
    const jsonObject: any = {};
    for (const key of Object.keys(filter)) {
      const value = filter[key as keyof Filter];
      if (Array.isArray(value)) {
        jsonObject[key] = value.join(',');
      } else {
        jsonObject[key] = value;
      }
    }
    return jsonObject;
  }

  convertJSONToFilter(jsonObj: any): Filter {
    const filter: any = new Filter(this.getUser().UserId);

    for (const key of Object.keys(jsonObj)) {
      const value = jsonObj[key];

      if (typeof filter[key] === 'undefined') {
        // Handle properties not defined in Filter class
        continue;
      }

      if (Array.isArray(value)) {
        filter[key] = value;
      } else {
        filter[key] = value;
      }
    }

    return filter;
  }

  stringToNumberArray(inputObj: any, mainObj: any): Record<string, number[]> {
    const resultObj: Record<string, any> = { ...mainObj }; // Create a shallow copy of the second object.

    for (const key in mainObj) {
      if (
        mainObj.hasOwnProperty(key) &&
        inputObj.hasOwnProperty(key) &&
        key != 'userId'
      ) {
        const value = inputObj[key];
        if (value) {
          const valuesArray = value.split(',').map(Number);
          resultObj[key] = valuesArray;
        }
      }
    }

    return resultObj;
  }

  // remove unwanted keys from object and return new object
  filterOutUnwantedKeys(filter: Filter, keysToExclude: string[]): Filter {
    const payload: any = { ...filter }; // Create a copy of the filter object
    keysToExclude.forEach((key) => delete payload[key]); // Delete unwanted keys
    return payload;
  }

  // Date Sorting
  addCombinedStringNumericSorting() {
    ($.fn.dataTable.ext.type.order as any)['combined-string-numeric-pre'] =
      function (data: any) {
        if (!data || typeof data !== 'string') {
          return 'NA';
        }

        const [datePart, timePart] = data.split(' ');
        const dateParts = datePart.split('-');
        const formattedDate = dateParts[2] + dateParts[1] + dateParts[0];
        const formattedTime = timePart ? timePart.replace(/:/g, '') : '000000';
        return formattedDate + formattedTime;
      };
  }

  setUTCDateTimeInPayload(payload: Filter, timePicker: boolean = false) {
    let sd;
    let ed;
    if (payload.DateTime.startDate.$d && payload.DateTime.endDate.$d) {
      sd = this.convertUserLocalTimeToUTC(payload.DateTime.startDate.$d);
      ed = this.convertUserLocalTimeToUTC(payload.DateTime.endDate.$d);
    } else {
      sd = payload.DateTime.startDate._d;
      // ed = moment().toString(); //current datetime to utc
      ed = payload.DateTime.endDate._d;
    }

    payload.startDateTime = this.convertUserLocalTimeToUTC(sd);
    payload.endDateTime = this.convertUserLocalTimeToUTC(ed);

    return payload;
  }

  convertUserLocalTimeToUTC(userLocalDate: any, format: string = ''): string {
    // Get the dynamic time zone code of the user's browser
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Convert user's local date to UTC
    const utcDate = moment(userLocalDate).utc();

    // Format the UTC date as YYYY-MM-DD HH:mm:ss
    const year = utcDate.year();
    const month = (utcDate.month() + 1 < 10 ? '0' : '') + (utcDate.month() + 1);
    const day = (utcDate.date() < 10 ? '0' : '') + utcDate.date();
    const hours = (utcDate.hours() < 10 ? '0' : '') + utcDate.hours();
    const minutes = (utcDate.minutes() < 10 ? '0' : '') + utcDate.minutes();
    const seconds = (utcDate.seconds() < 10 ? '0' : '') + utcDate.seconds();

    let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    if ('date' == format) {
      formattedDate = `${year}-${month}-${day}`;
    }

    return formattedDate;
  }

  convertUTCToUserLocalTime(date: Date, format: string = ''): string {
    var localTime = moment.utc(date).toDate();

    // Create a new Date object with the UTC date's milliseconds
    const utcDate = new Date(localTime);

    // Get the dynamic time zone code of the user's browser
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get the dynamic locale from the user's browser
    const userLocale = navigator.language;

    // Format the date as YYYY-MM-DD HH:mm:ss
    const year = utcDate.getFullYear();
    const month =
      (utcDate.getMonth() + 1 < 10 ? '0' : '') + (utcDate.getMonth() + 1);
    const day = (utcDate.getDate() < 10 ? '0' : '') + utcDate.getDate();
    const hours = (utcDate.getHours() < 10 ? '0' : '') + utcDate.getHours();
    const minutes =
      (utcDate.getMinutes() < 10 ? '0' : '') + utcDate.getMinutes();
    const seconds =
      (utcDate.getSeconds() < 10 ? '0' : '') + utcDate.getSeconds();

    // let formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    let formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    if (format == 'date') {
      formattedDate = `${day}-${month}-${year}`;
    }
    if (format == 'chartdate') {
      formattedDate = `${day}-${month}`;
    }

    return formattedDate;
  }

  renameKeys(obj: any, newKeys: any) {
    const keyValues = Object.keys(obj).map((key) => {
      const newKey = newKeys[key] || key;
      return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
  }

  setPermissions(data: any) {
    let srArr: string[] = ['view', 'edit', 'add', 'delete', 'pdf', 'excel'];
    let permissionsArr: any = [];
    for (let i = 0; i < data[0].SubMenu.length; i++) {
      let submenu = data[0].SubMenu[i].SubbMenu;
      if (submenu.length) {
        for (let index = 0; index < submenu.length; index++) {
          let tempPermArr = submenu[index].Permission.split(',');
          let controller = submenu[index].Controller;
          let companyId = data[0].SubMenu[i].CompanyId;
          let result: { [key: string]: number } = {};

          srArr.forEach((key, index) => {
            result[key] = tempPermArr[index];
          });
          result['companyId'] = companyId;
          permissionsArr.push({ [controller]: { ...result } });
        }
      } else {
        let tempPermArr = data[0].SubMenu[i].Permission.split(',');
        let controller = data[0].SubMenu[i].Controller;
        let companyId = data[0].SubMenu[i].CompanyId;
        let result: { [key: string]: number } = {};

        srArr.forEach((key, index) => {
          result[key] = tempPermArr[index];
        });
        result['companyId'] = companyId;
        permissionsArr.push({ [controller]: { ...result } });
      }
    }
    localStorage.setItem('permissionsArr', JSON.stringify(permissionsArr));
  }

  checkPermission(page: string, type: any, SelcmpId: any = null) {
    page = page.replace('/', '');
    let permArr: any = localStorage.getItem('permissionsArr');
    const permissionsArr = JSON.parse(permArr);
    SelcmpId = SelcmpId ?? localStorage.getItem('SelcmpId');
    if (permissionsArr) {
      const obj = this.findObject(permissionsArr, page, SelcmpId);
      if (!obj || !obj[page]) return 'out';
      if (
        obj[page][type] === 'True' &&
        obj[page]['companyId'].includes(SelcmpId.toString())
      ) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkPermission1(page: string, type: any, SelcmpId: any = null) {
    //will have '/' so need to remove
    page = page.replace('/', '');

    let permArr: any = localStorage.getItem('permissionsArr');
    const permissionsArr = JSON.parse(permArr);
    if (permissionsArr) {
      const obj = this.findObject1(permissionsArr, page);
      if (obj && obj[page][type]) {
        if (obj[page][type] == 'True') {
          return true;
        }
        return false;
      }
      return false;
    } else {
      return false;
    }
  }

  // Function to find the dashboard object
  findObject(permissionsArr: any, page: string, SelcmpId: string) {
    for (const obj of permissionsArr) {
      if (obj[page]) {
        const companyIds = obj[page]['companyId']
        if (companyIds && companyIds == SelcmpId) {
          return obj;
        }
      }
    }
    return null;
  }

  findObject1(array: any, page: string) {
    return array.find((obj: any) => {
      const key = Object.keys(obj)[0];
      return key == page;
    });
  }

  dtScrollFunction(id = '') {
    let dataTableScrollHead = document.querySelector('.dataTables_scrollHead');
    if (id) {
      dataTableScrollHead = document.querySelector(
        '#' + id + ' .dataTables_scrollHead'
      );
    }
    if (dataTableScrollHead) {
      $('.dataTables_scrollHead').css({
        'overflow-x': 'scroll',
      });
      dataTableScrollHead.addEventListener('scroll', (event: any) => {
        let scrollBody = event.target.parentElement.children[1];
        scrollBody.scrollLeft = event.target.scrollLeft;
        $(scrollBody).trigger('scroll');
      });
    }
  }

  reorderObjectKeys(obj: any, orderArray: string[]) {
    let reorderedObject: { [key: string]: any } = {};
    orderArray.forEach((key: any) => {
      if (obj.hasOwnProperty(key)) {
        reorderedObject[key] = obj[key];
      }
    });
    return reorderedObject;
  }

  sortingSelectedVal(options: any[], selectedValues: number[]) {
    return options.slice().sort((a, b) => {
      const aIndex = selectedValues.indexOf(a.Id);
      const bIndex = selectedValues.indexOf(b.Id);

      if (aIndex === -1 && bIndex === -1) {
        return a.Id - b.Id;
      }

      if (aIndex === -1) {
        return 1;
      }

      if (bIndex === -1) {
        return -1;
      }

      return aIndex - bIndex;
    });
  }

  sortingSelectedVal1(options: any[], selectedValues: number[]) {
    return options.slice().sort((a, b) => {
      const aIndex = selectedValues.indexOf(a.roleId);
      const bIndex = selectedValues.indexOf(b.roleId);

      if (aIndex === -1 && bIndex === -1) {
        return a.roleId - b.roleId;
      }

      if (aIndex === -1) {
        return 1;
      }

      if (bIndex === -1) {
        return -1;
      }

      return aIndex - bIndex;
    });
  }

  getRandomColors(count: number): string[] {
    const colors = [];
    for (let i = 0; i < count; i++) {
      const randomIndex = Math.floor(Math.random() * this.colorArray.length);
      colors.push(this.colorArray[randomIndex]);
    }
    return colors;
  }

  convertMinutesToHHMMSS(minutes: any) {
    const seconds = 0; // Since you only provided minutes

    const formattedHours =
      Math.floor(minutes / 60) < 10
        ? `0${Math.floor(minutes / 60)}`
        : Math.floor(minutes / 60);
    const formattedMinutes =
      minutes % 60 < 10
        ? `0${(minutes % 60).toFixed()}`
        : (minutes % 60).toFixed();
    const formattedSeconds = 0 < 10 ? `00` : 0;

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  convertDateTOYYMMDD(date: Date): string {
    const year = date.getFullYear(); // Get the last two digits of the year
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const day = date.getDate();

    // Ensure that single-digit months and days are padded with leading zeros
    const formattedYear = year < 10 ? '0' + year : year.toString();
    const formattedMonth = month < 10 ? '0' + month : month.toString();
    const formattedDay = day < 10 ? '0' + day : day.toString();

    return formattedYear + '-' + formattedMonth + '-' + formattedDay;
  }

  numberWithCommas(value: any, module: any = ''): string {
    if (value === null || value === undefined) {
      return '';
    }
    var part = value.toString().split(' ');
    var part1 = value.toString().split('/');
    var formattedNumber = '';
    if (module == 'key-indicators') {
      formattedNumber =
        Number(part[0]).toLocaleString('en-IN') +
        ' ' +
        part[1] +
        ' ' +
        part[2] +
        ' ' +
        Number(part[3]).toLocaleString('en-IN') +
        ' ' +
        part[4];
    } else if (module == 'txn') {
      formattedNumber =
        Number(part1[0]).toLocaleString('en-IN') +
        '/' +
        Number(part1[1]).toLocaleString('en-IN');
    } else if (part[0] && part[1]) {
      formattedNumber = Number(part[0]).toLocaleString('en-IN') + ' ' + part[1];
    } else {
      formattedNumber = Number(part[0]).toLocaleString('en-IN');
    }
    return formattedNumber;
  }

  numberWithCommas1(x: number) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  validateInput(input: any): string {
    // Convert input to string
    let inputString = input.toString();
    // Replace HTML tags
    let stripHtmlTags = inputString.replace(/<[^>]*>/g, '');
    // Remove special characters using a regular expression
    let validInputString = stripHtmlTags.replace(/[^\w\s]/gi, '').trim();
    return validInputString;
  }

  // Check if the pressed key is a number key
  isNumberKey(event: KeyboardEvent): boolean {
    const key = event.key;
    const input = event.target as HTMLInputElement;

    // If the pressed key is a number key or a decimal point
    if (
      (key >= '0' && key <= '9') || // Numbers 0-9
      key === '.' || // Decimal point
      key === 'Backspace' || // Backspace
      key === 'Delete' || // Delete
      key === 'ArrowLeft' || // Arrow Left
      key === 'ArrowRight' // Arrow Right
    ) {
      // Allow input if there are less than two digits after the decimal point
      if (input.value.includes('.')) {
        const bdecimalPart = input.value.split('.')[0];
        const decimalPart = input.value.split('.')[1];
        if (bdecimalPart.length > 5) {
          // Allowing ArrowLeft and ArrowRight if cursor is before or after the decimal
          if (
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Backspace' ||
            key === 'Delete'
          )
            return true;
          event.preventDefault();
          return false;
        }
        if (decimalPart && decimalPart.length >= 2) {
          // Allowing ArrowLeft and ArrowRight if cursor is before or after the decimal
          if (
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Backspace' ||
            key === 'Delete'
          )
            return true;
          event.preventDefault();
          return false;
        }
      }
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getFormattedDate(date: Date): string {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2); // Extract last two digits of the year

    return `${month}'${year}`;
  }

  getDefaultFilter(payload: any) {
    payload.cmpId = localStorage.getItem('SelcmpId')
      ? localStorage.getItem('SelcmpId')
      : this.getUser().CompanyId;
    payload.icId = payload?.icId?.length ? payload?.icId : this.getUser().IcID;
    // payload.sbgId = payload?.sbgId?.length ? payload?.sbgId : this.getUser().SbgId;
    // payload.buId = payload?.buId?.length ? payload?.buId : this.getUser().BuId;
    // payload.clusterId = payload?.clusterId?.length ? payload?.clusterId : this.getUser().ClrId;
    payload.jobId =
      payload?.jobId?.length || payload.jobId
        ? payload?.jobId
        : this.getUser().JbmId;
    return payload;
  }

  getNumericValue(value: string): number {
    return Number(value.replace(/[^0-9.]/g, '')); // Extracts numeric part
  }

  logout() {
    var url = ConfigApi.URLS.LOGOUT_URL;
    const payload = {
      userId: this.getUser().UserId,
      description: 'logout due to insufficient permission',
    };
    this.apiCallingService
      .callAuthPostAPI(payload, 'POST', url)
      .subscribe((res) => {
        if (this.apiCallingService.handleSuccess(JSON.parse(res))) {
          var LoginWith = localStorage.getItem('LoginWith');
          localStorage.clear();
          // this.router.navigateByUrl("login");
          this.toastr.success(
            'You have been forcefully logged out due to insufficient permissions. Please log in again.'
          );
          sharedBroadcast.postMessage('logout');

          // if (LoginWith == 'SSO') {
          //   this.authService.logoutRedirect({
          //     postLogoutRedirectUri: ConfigApi.HOST_BASE_URL
          //   });
          // } else {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          // }
        }
      });
  }

  LTCSessionOut(): void {
    var url = ConfigApi.URLS.LTC_SESSION_OUT;
    const payload = {
      userid: atob(this.getUser().UserId),
      token: this.user[0].TokenKey,
    };
    this.apiCallingService.callAuthPostAPI(payload, 'POST', url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(JSON.parse(res))) {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      },
      (error) => {
        let tmpMsg = JSON.parse(error.error);
        this.toastr.error(tmpMsg.ResponseMessage);
      }
    );
  }
}
